export const CHAT_ALERT_CLOSED = 'chat_alert_closed';
export const CHAT_OPENED = 'chat_opened';
